import { render, staticRenderFns } from "./RadialBarChart.vue?vue&type=template&id=70d8d5a8&scoped=true&"
import script from "./RadialBarChart.vue?vue&type=script&lang=js&"
export * from "./RadialBarChart.vue?vue&type=script&lang=js&"
import style0 from "./RadialBarChart.vue?vue&type=style&index=0&id=70d8d5a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d8d5a8",
  null
  
)

export default component.exports